import { IRegion } from '../../../types/geoSwitcher';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ECurrentRegionActionTypes, TCurrentRegion } from './types';

export const setCurrentRegion: (region: IRegion) => TCurrentRegion = actionGenerator<
  ECurrentRegionActionTypes.Set,
  IRegion
>(ECurrentRegionActionTypes.Set);
